export const BetaBanner = () => (
  <s-banner heading="CodWay está en Beta" tone="warning" dismissible>
    Esta aplicación se encuentra actualmente en versión <strong>Beta</strong>.
    Estamos bajo mejora continua y es posible que encuentres cambios frecuentes,
    nuevas funcionalidades y correcciones en el camino.
    <br />
    <br />
    Si experimentas algún problema o tienes sugerencias, no dudes en
    contactarnos. Tu feedback es fundamental para seguir mejorando la
    experiencia de CodWay.
  </s-banner>
);
